import React from 'react';

const ModalSuccessBody = ({ children }: React.PropsWithChildren<React.ReactNode>): JSX.Element => {
	return <>{children}</>;
};

ModalSuccessBody.displayName = 'ModalSuccessBody';

export default ModalSuccessBody;
